export default (response) => {
	const conditions = [0, 1, 2, 3, 4];
	const responseGraphValues = response?.relatedITApplicationWithRiskAssessmentControlCount ?? [];

	const graphValues = conditions.map((condition) => {
		const items = responseGraphValues.filter(({countRelatedControls}) => countRelatedControls === condition);
		return {
			ids: items.map(({itApplicationId}) => itApplicationId),
			count: items.length
		};
	});

	return {
		...(response?.itApplicationMetricsCount ?? {}),
		graphValues
	};
};
